import { parse as qs_parse, stringify as qs_stringify } from 'qs';
import { baseURL } from './config/index.js';
/**
 * 获取url search中参数
 * @param name
 * @returns {string}
 */

export function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = window.location.search.substr(1).match(reg);

  if (r != null) {
    return decodeURIComponent(r[2]);
  }

  return '';
}
/**
 * 通过iframe发送url 例如调用分享url scheme等
 * @param url {string}
 * @param title {string}
 */

export function reqUrlByIframe(url, title) {
  if (title) {
    document.title = title;
  }

  var i = document.createElement('iframe');
  i.src = url;
  i.style.display = 'none';

  i.onerror = i.onload = function () {
    setTimeout(function () {
      i.parentNode && i.parentNode.removeChild(i);
    }, 100);
  };

  setTimeout(function () {
    i.parentNode && i.parentNode.removeChild(i);
  }, 800);
  document.body.appendChild(i);
}
export function getNewSearch(key, value) {
  var qs_obj = qs_parse(window.location.search.slice(1));
  qs_obj[key] = value;
  var qs_str = qs_stringify(qs_obj);
  return qs_str;
}
export function gotoSearchPage(page, isReplace) {
  var qs_str = getNewSearch('page', page);

  if (isReplace) {
    window.location.replace(window.location.origin + window.location.pathname + '?' + qs_str + window.location.hash); // 替换当前页
  } else {
    window.location.search = qs_str; // 打开新页面
  }
}
export function gotoAppDownload() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  window.location = baseURL + 'static/toapp/toapp.html?u=' + url;
}
export function gotoAppTaxiDownload() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  window.location = baseURL + 'static/toapp/toapptaxi.html?u=' + url;
}